import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFAQs } from '../features/faqs/faqSlice';
import { Helmet } from 'react-helmet-async';

const FAQ = () => {
  const dispatch = useDispatch();
  const { faqs, isLoading } = useSelector((state) => state.faqs);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    dispatch(getFAQs());
  }, [dispatch]);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (isLoading) {
    return (
      <div className="py-12">
        <section className="container mx-auto px-4">
          <div className="bg-white rounded-2xl border border-gray-200 p-8">
            <div className="space-y-4">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="animate-pulse">
                  <div className="h-8 bg-gray-200 rounded-xl w-full mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>FAQ | POLBIS PRESS</title>
      </Helmet>

      <div className="py-12">
        <section className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Pertanyaan yang Sering Diajukan</h1>
            <p className="text-lg text-gray-600">Jelajahi jawaban atas pertanyaan umum tentang penerbit kami.</p>
          </div>

          <div className="max-w-3xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <div key={faq._id} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between focus:outline-none"
                >
                  <span className="text-lg font-semibold text-gray-900">{faq.question}</span>
                  <svg
                    className={`w-6 h-6 text-gray-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <div className="text-gray-700 leading-relaxed prose-content" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default FAQ;
